import script from "./OverviewCompanyBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewCompanyBlock.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewCompanyBlock.vue?vue&type=style&index=0&id=2b466d9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b466d9a"]])

export default __exports__